import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { environment } from '@env/environment';

import { ru as RU } from 'date-fns/locale';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NZ_DATE_CONFIG, NZ_DATE_LOCALE, NZ_I18N } from 'ng-zorro-antd/i18n';
import { ru_RU } from 'ng-zorro-antd/i18n';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
const ngZorroConfig: NzConfig = {
    notification: { nzPlacement: 'bottomLeft', nzDuration: 10000, nzPauseOnHover: true }
};

import {
    PublicApiService,
} from '@utils/api.service';


import { AppComponent } from './app.component';

import ru from '@angular/common/locales/ru';
registerLocaleData(ru);

import { CustomRouteReuseStrategy, ROUTES } from './app.routing';
import { GlobalErrorHandler } from './app.error-handler.service';
import { VzDividerDirective } from '@utils/vz-divider';
import { DmTreeComponent } from '@utils/dm-tree';
import { ErrorPanelComponent } from '@utils/error-panel';
import { TextViewerModule } from './viewer';
import { BaseService } from '@utils/base-service';

const ROUTING = RouterModule.forRoot(ROUTES, {
    enableTracing: false,
    bindToComponentInputs: true,
    paramsInheritanceStrategy: 'always',
    enableViewTransitions: true
});

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        if (registrations.length) {
            for (const registration of registrations) {
                registration.unregister();
            }
        }
    });
}

const PROVIDERS: any = [
    { provide: ErrorHandler, useClass: environment.production ? GlobalErrorHandler : ErrorHandler },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    { provide: NZ_I18N, useValue: ru_RU },
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
    { provide: NZ_DATE_LOCALE, useValue: RU },
    BaseService,
    PublicApiService,
    provideHttpClient(withInterceptorsFromDi()),
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        ROUTING,
        BrowserModule,
        BrowserAnimationsModule,
        NzButtonModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        TextViewerModule,
        VzDividerDirective,
        ErrorPanelComponent,
        DmTreeComponent
    ],
    providers: PROVIDERS,
    bootstrap: [AppComponent]
})
export class AppModule { }
